/**
 * The web half of `@tonnie/copilot-core`'s `storage` injection point.
 *
 * `localStorage` is synchronous, so `get` returns the value directly and the
 * engine resolves the saved answer-depth in its lazy state initializer — the
 * first paint already shows the user's choice, exactly as before the engine was
 * extracted. (React Native passes an AsyncStorage adapter instead, which the
 * engine hydrates in an effect.)
 *
 * Every access is guarded: Safari private mode and storage-disabled profiles
 * throw on `localStorage`, and losing a depth preference must never take the
 * Companion down with it.
 */

import type { CoPilotCoreStorage } from '@tonnie/copilot-core';

export const browserStorage: CoPilotCoreStorage = {
  get(key) {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch {
      /* private mode / storage disabled — in-memory for this session is fine */
    }
  },
};
